/**
 * 异常捕获处理
 * @param code  HTTP数据状态码
 * @param message 提示信息
 */
 import { Message } from 'element-ui';
 import Vue from 'vue'
 import router from './router';
 import store from './store';


 /**
  * code码\
  * 400 报错
  * 200 成功
  * 500 服务器错误
  * 422 登录态失效
  * 401 无权进入404
  */



 export default function (code, message) {
     return new Promise((res, rej) => {
         if (code == 200) {
             res();
         } else if(code == 401){
             message = "登录已过期，请退出后重新登录";
             Message({
                 message,
                 type: 'error',
             });
             sessionStorage.clear();
             location.href = '/';
             rej(new Error(message));
         } else {
             const msg = message || '操作失败，请稍后重试';
             Message({
                 message: msg,
                 type: 'error',
             });
             rej(new Error(msg));
         }
     })
 }



// WEBPACK FOOTER //
// ./src/codeType.js